// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../settings_ctx';
import {Root as Root_current} from './premium_land';
import {Root as Root_new} from './premium_land2';
import {check_from_bext} from '../../ui/premium/use_premium_page';
import experiment_init from '../../experiment_init';

const check_bext = ()=>{
    return check_from_bext(window?.location?.search||'');
};

export const Root = props=>{
    const {theme_name} = useContext(Settings_context);
    if (theme_name=='hola2023')
        return <Root_new {...props}/>;
    return <Root_current {...props}/>;
};
Root.meta = {
    meta: {
        title: 'Hola | Choose Your Premium Plan & Subscribe Today',
        description: 'Unlock a world of unrestricted browsing with Hola '
            +'Premium! Choose your plan & subscribe today to enjoy '
            +'unrestricted browsing on multiple devices today.',
        canonical_url: 'https://hola.org/premium'
    },
    ssr_force: true,
    no_ssr: false,
    translation: {enabled: true, detect_by_country: true,
        white_list: ['en', 'ru', 'es']},
    nosearch: true,
    nav_opt: ()=>{
        if (experiment_init.ui_test.test_premium_lp_v2)
            return {transparent: 1};
    },
    nomenu: ()=>!!experiment_init.ui_test.test_premium_lp_v2,
    headlogo: check_bext,
    footless: check_bext,
    headless: ()=>{
        return experiment_init.ui_test.test_payment_page_order_summary
          && check_bext();
    },
};
